import { styled } from 'styled-components'
import { themeColor } from '@hud/web-components/theme/colors';

const Container = styled.div`
  max-width: 450px;
  font-size: 14px;

  h4 {
    margin-top: 0;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }

  p {
    font-size: 14px;
    line-height: 164%;
  }

  a {
    color: ${themeColor('turquoise')};
    text-decoration: underline;
  }
`

export default function(){
  return (
    <Container>
      <h4>No Endpoints Data</h4>
      <p>If you just setup your service, it might take several minutes to present endpoint metrics. Make sure your endpoints are triggered.</p>
      <p>Trouble setting up? <a href="https://docs.hud.io/docs/node-sdk-ie" target="_blank" rel="noopener noreferrer">View the troubleshooting guide</a>.</p>
    </Container>
  )
}
